import { render } from "./participant-list.vue?vue&type=template&id=0813358a&scoped=true&ts=true"
import script from "./participant-list.vue?vue&type=script&lang=ts"
export * from "./participant-list.vue?vue&type=script&lang=ts"

import "./participant-list.vue?vue&type=style&index=0&id=0813358a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0813358a"]])

export default __exports__